// Typed access to build-time configuration. Only VITE_* values are exposed to
// the client and none of them are secrets (the anon key is public by design;
// RLS protects the data).

function read(names: string[], fallback?: string): string {
  for (const name of names) {
    const value = import.meta.env[name] as string | undefined;
    if (value) return value;
  }
  if (fallback !== undefined) return fallback;
  throw new Error(`Missing environment variable ${names[0]}. Copy .env.example to .env.local and fill it in.`);
}

export type AppEnvironment = 'development' | 'staging' | 'production';

export const env = {
  // No fallback: a deployed build must never silently point at a local database.
  // NEXT_PUBLIC_* names are accepted because the Vercel Supabase integration creates them.
  supabaseUrl: read(['VITE_SUPABASE_URL', 'NEXT_PUBLIC_SUPABASE_URL']),
  supabaseAnonKey: read(['VITE_SUPABASE_ANON_KEY', 'NEXT_PUBLIC_SUPABASE_ANON_KEY', 'NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY']),
  appUrl: read(['VITE_APP_URL'], typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5173'),
  appEnv: read(['VITE_APP_ENV', 'VERCEL_ENV'], 'development') as AppEnvironment,
  get isProduction() {
    return this.appEnv === 'production';
  },
};
